module.exports = __webpack_public_path__ + "img/security-audit-img-6.ce3a5dbb.png";